// import React, { useMemo, useState } from "react";
// import "../assets/css/Grt.css";
// import { Edit, Trash } from "lucide-react";
// import { toast } from "react-toastify";

// const GRTManagement = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(1);
//   const [loading,setLoading]=useState(false)
//   const ITEMS_PER_PAGE_OPTIONS = [1, 2, 4];
//   const [formData, setFormData] = useState({
//     branch: "",
//     officer: "",
//     description: "",
//     startDate: "",
//     center: "",
//     group: "",
//   });

//   const [data, setData] = useState([
//     {
//       id: 1,
//       grtId:"GRT001",
//       cgtId: "CGT001",
//       center: "Center A",
//       group: "Group X",
//       description: "Initial CGT session",
//       startDate: "2025-10-01",
//       grt:"28/04/2008",
//       employee:"001",
//       entryDate:"05/08/2022",
//     },
//     {
//       id: 2,
//       grtId:"GRT001",
//       cgtId: "CGT002",
//       center: "Center B",
//       group: "Group Y",
//       description: "Follow-up CGT",
//       startDate: "2025-10-03",
//       grt:"21/04/2008",
//       employee:"002",
//       entryDate:"05/08/2023",
//     },
//   ]);


//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleAdd = () => {
//     if (!formData.branch || !formData.officer || !formData.center || !formData.group) {
//       toast.warn("Please fill all required fields.");
//       return;
//     }

//     const newData = {
//       id: data.length + 1,
//       grtId: `GRT00${data.length + 1}`,
//       cgtId: `CGT00${data.length + 1}`,
//       center: formData.center,
//       group: formData.group,
//       description: formData.description,
//       startDate: formData.startDate,
//       grt:formData.grt,
//       employee:formData.employee,
//       entryDate:formData.entryDate,
//     };
//     setData([...data, newData]);
//     setFormData({
//       branch: "",
//       description: "",
//       startDate: "",
//       center: "",
//       group: "",
//     });
//   };

//   // Search + Pagination
//   const filteredData = useMemo(() => {
//     return data.filter((item) =>
//       Object.values(item)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase())
//     );
//   }, [data, searchQuery]);

//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);

//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };
//   return (
//     <div className="group-grt-container">
//       <h1 className="group-grt-heading">Group GRT</h1>

//       {/* ================= FORM ================= */}
//       <section className="group-grt-top">
//         <form className="group-grt-form" onSubmit={handleAdd}>
//           <div className="group-grt-form-section">
//             <div className="group-grt-form-input-fields">
//                <label>Branch</label>
//              <select name="branch" value={formData.branch} onChange={handleChange}>
//                <option value="">Select Branch</option>
//                <option value="Branch A">Branch A</option>
//                <option value="Branch B">Branch B</option>
//              </select>
//             </div>

//             <div className="group-grt-form-input-fields">
//                <label>Employee</label>
//              <select name="officer" value={formData.officer} onChange={handleChange}>
//                <option value="">Select Employee</option>
//                <option value="Ravi Kumar">Ravi Kumar</option>
//                <option value="Anita Sharma">Anita Sharma</option>
//              </select>
//             </div>

//             <div className="group-grt-form-input-fields">
//              <label>Description</label>
//              <input
//                type="text"
//                name="description"
//                value={formData.description}
//                onChange={handleChange}
//                placeholder="Enter description"
//              />
//             </div>

//             <div className="group-grt-form-input-fields">
//               <label>GRT Start Date</label>
//              <input
//                type="date"
//                name="startDate"
//                value={formData.startDate}
//                onChange={handleChange}
//              />
//             </div>

//             <div className="group-grt-form-input-fields">
//               <label>Center</label>
//              <input
//                type="text"
//                name="center"
//                value={formData.center}
//                onChange={handleChange}
//                placeholder="Enter Center"
//              />
//             </div>

//             <div className="group-grt-form-input-fields">
//              <label>Group</label>
//              <select name="group" value={formData.group} onChange={handleChange}>
//                <option value="">Select Group</option>
//                <option value="Group X">Group X</option>
//                <option value="Group Y">Group Y</option>
//              </select>
//             </div>

//             <div className="group-grt-form-input-fields">
//              <label>CGT ID</label>
//              <input
//                type="text"
//                name="center"
//                value={formData.center}
//                onChange={handleChange}
//                placeholder="Enter Center"
//              />
//             </div>
//           </div>
//           <div className="group-grt-form-submit-btn">
//              <button>Add</button>
//           </div>
//         </form>
//       </section>

//       {/* ================= REPORT SECTION ================= */}
//       <div className="group-grt-report-container">
//         <h1>GRT Details</h1>
//         <div className="group-grt-report-filter-div">
//           <input
//             type="text"
//             placeholder="Search..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />

//           <div className="group-grt-filter">
//             <label>Show </label>
//             <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
//               {ITEMS_PER_PAGE_OPTIONS.map((num) => (
//                 <option key={num} value={num}>
//                   {num}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//         </div>

//         <div className="group-grt-report-table-container">
//           <table className="group-grt-report-table">
//             <thead>
//               <tr>
//                 <th>Sr. No.</th>
//                <th>GRT ID</th>
//                <th>CGT ID</th>
//                <th>Center Name</th>
//                <th>Group Name</th>
//                <th>Description</th>
//                <th>GRT Date</th>
//                <th>Employee</th>
//                <th>Entry Date</th>
//                <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((item, index) => (
//                   <tr key={item.id}>
//                     <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                  <td>{item.grtId}</td>
//                  <td>{item.cgtId}</td>
//                  <td>{item.center}</td>
//                  <td>{item.group}</td>
//                  <td>{item.description}</td>
//                  <td>{item.startDate}</td>
//                  <td>{item.employee}</td>
//                  <td>{item.entryDate}</td>
//                 <td className="group-action-btns">
//                       <Edit
//                         className="edit-icon"
//                       />
//                       <Trash
//                         className="delete-icon"
//                       />
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   {loading ? (
//                     <td colSpan="10" style={{ textAlign: "center" }}>
//                       Loading...
//                     </td>
//                   ) : (
//                     <td colSpan="10" style={{ textAlign: "center" }}>
//                       No results found
//                     </td>
//                   )}
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {filteredData.length > itemsPerPage && (
//           <div className="group-grt-pagination-div">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage(currentPage - 1)}
//             >
//               ⬅ Prev
//             </button>

//             <span>
//               {" "}
//               Page {currentPage} of {totalPages}{" "}
//             </span>

//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage(currentPage + 1)}
//             >
//               Next ➡
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GRTManagement;





import React, { useEffect, useMemo, useState } from "react";
import "../assets/css/Grt.css";
import { Edit, Trash, CheckCircle, ArrowRightIcon, ArrowLeftIcon } from "lucide-react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const GRTManagement = () => {
  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const navigate=useNavigate()

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false); 
  const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100, "All"];

  const [data, setData] = useState([]);

  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedGrt, setSelectedGrt] = useState(null);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchGrt = async () => {
    if (!profile?.superAdminId) return;
    setLoading(true);
    try {
      const limitValue = itemsPerPage === "All" ? 100000 : itemsPerPage;
      const res = await axios.get(`https://payyug.in/api/grt/list`, {
        params: {
          superAdminId: profile?.superAdminId,
          BranchId:profile?.branchId,
          page: currentPage,
          limit: limitValue,
        },
      });
      setData(res?.data?.data || []);
      setCurrentPage(res?.data?.pagination?.page || 1);
      setTotalPages(res?.data?.pagination?.total || 1);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGrt();
  }, [profile, currentPage, itemsPerPage]);

  // Open popup and store target row data
  const handleOpenApproveModal = (item) => {
    setSelectedGrt(item);
    setIsModalOpen(true);
  };

  // Close popup and clear data
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedGrt(null);
  };

  // Handle Approve API submission
  const handleApproveSubmit = async () => {
    if (!selectedGrt) return;
    
    setSubmitting(true);
    try {
      const payload = {
        grtId: Number(selectedGrt.id),
        updateBy: Number(profile?.id || 2) 
      };

      const res = await axios.post(`https://payyug.in/api/grt/approve`, payload);
      
      toast.success(res?.data?.message || "GRT approved successfully!");
      handleCloseModal();
      fetchGrt(); 
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to approve GRT row.");
    } finally {
      setSubmitting(false);
    }
  };

  const filteredData = useMemo(() => {
    if (!searchQuery) return data;
    return data.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [data, searchQuery]);

  const handleItemsPerPageChange = (e) => {
    const val = e.target.value;
    setItemsPerPage(val === "All" ? "All" : Number(val));
    setCurrentPage(1);
  };

  const numericItemsPerPage = itemsPerPage === "All" ? data.length || 1 : itemsPerPage;

  return (
    <div className="group-grt-container">
       {/* Back wrapper */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <ArrowLeftIcon
          onClick={() => navigate(-1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />

        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          Group GRT
        </h2>

        <ArrowRightIcon
          onClick={() => navigate(1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />
      </div>

      {/* ================= REPORT SECTION ================= */}
      <div className="group-grt-report-container">
        <div className="group-grt-report-filter-div">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <div className="group-grt-filter">
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="group-grt-report-table-container">
          <table className="group-grt-report-table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Branch Id</th>
                <th>Center Id</th>
                <th>Group Id</th>
                <th>GRT ID</th>
                <th>Description</th>
                <th>GRT Date</th>
                <th>Entry Date</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={item.id || index}>
                    <td>{(currentPage - 1) * numericItemsPerPage + index + 1}</td>
                    <td>{item.BranchId||"N/A"}</td>
                    <td>{item.CenterId||"N/A"}</td>
                    <td>{item.groupId||"N/A"}</td>
                    <td>{item.GRTTID||"N/A"}</td>
                    <td>{item.Description||"N/A"}</td>
                    <td>{(item.GRTDate||item.GRT_Date)?new Date(item.GRTDate||item.GRT_Date).toLocaleDateString("en-GB"):"N/A"}</td>
                    <td>{item.Entry_Date?new Date(item.Entry_Date).toLocaleDateString("en-GB"):"N/A"}</td>
                    <td>{item.status}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {itemsPerPage !== "All" && totalPages > 1 && (
          <div className="group-grt-pagination-div">
            <button
              disabled={currentPage === 1 || loading}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            >
              &larr; Prev
            </button>

            <span>
              {" "}
              Page {currentPage} of {totalPages}{" "}
            </span>

            <button
              disabled={currentPage === totalPages || loading}
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            >
              Next &rarr;
            </button>
          </div>
        )}
      </div>

      {/* ================= APPROVAL POPUP MODAL ================= */}
      {isModalOpen && (
        <div className="modal-overlay" style={modalStyles.overlay}>
          <div className="modal-content" style={modalStyles.content}>
            <h2>Approve GRT Confirmation</h2>
            <hr />
            <p style={{ margin: "15px 0" }}>
              Are you sure you want to approve GRT Record: <strong>{selectedGrt?.grtId}</strong>?
            </p>
            
            <div style={modalStyles.preview}>
              <strong>Payload Preview:</strong>
              <pre style={{ margin: "5px 0 0 0" }}>
                {JSON.stringify({ grtId: selectedGrt?.id, updateBy: profile?.id || 2 }, null, 2)}
              </pre>
            </div>

            <div style={modalStyles.btnContainer}>
              <button 
                onClick={handleCloseModal} 
                disabled={submitting}
                style={modalStyles.cancelBtn}
              >
                Cancel
              </button>
              <button 
                onClick={handleApproveSubmit} 
                disabled={submitting}
                style={modalStyles.confirmBtn}
              >
                {submitting ? "Approving..." : "Confirm Approval"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex", justifyContent: "center", alignItems: "center",
    zIndex: 1000,
  },
  content: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "400px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  preview: {
    backgroundColor: "#f4f4f5",
    padding: "10px",
    borderRadius: "4px",
    fontSize: "12px",
    fontFamily: "monospace",
    marginBottom: "15px",
  },
  btnContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  cancelBtn: {
    padding: "8px 16px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
  confirmBtn: {
    padding: "8px 16px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#22c55e",
    color: "#fff",
    cursor: "pointer",
  },
};

export default GRTManagement;